import Cookies from 'js-cookie'

import {
  SERVICE_CONNECTION_LATEST_ACCESS_COOKIES,
  SERVICE_CONNECTION_PAGE_COOKIES,
} from 'interfaces/constants/cookies'
import { ScrollToItemType } from 'interfaces/types'
import { fastdom } from 'utils/fastdom'

import { CarePathColorPattern, CarePathColorType } from './constant'

type SEVICE_COOKIE_TYPE = {
  pageId: string
  audienceId: string
  audienceTermId: string | number
  funnelId: string
}

export const getPageCookies = (slug: string): SEVICE_COOKIE_TYPE =>
  (JSON.parse(
    Cookies.get(SERVICE_CONNECTION_PAGE_COOKIES) || '[]',
  ) as SEVICE_COOKIE_TYPE[]).filter((i) => i.pageId === slug)?.[0]

export const addPageCookies = ({
  pageId,
  audienceId = '',
  audienceTermId = '',
  funnelId = '',
}: {
  pageId: string
  audienceId: string
  audienceTermId: string | number
  funnelId?: string
}) => {
  const curCookieJson: SEVICE_COOKIE_TYPE[] = JSON.parse(
    Cookies.get(SERVICE_CONNECTION_PAGE_COOKIES) || '[]',
  )
  const curPageIndex = curCookieJson.findIndex((i) => i.pageId === pageId)

  if (curPageIndex === -1) {
    curCookieJson.push({
      pageId,
      audienceId,
      audienceTermId,
      funnelId,
    })
  } else {
    curCookieJson[curPageIndex] = {
      pageId,
      audienceId,
      audienceTermId,
      funnelId,
    }
  }
  Cookies.set(SERVICE_CONNECTION_PAGE_COOKIES, JSON.stringify(curCookieJson))
}

export const setAudienceTermId = (
  slug: string,
  audienceTermId: string | number,
) => {
  const curCookieJson: SEVICE_COOKIE_TYPE[] = JSON.parse(
    Cookies.get(SERVICE_CONNECTION_PAGE_COOKIES) || '[]',
  )
  const curPageIndex = curCookieJson.findIndex((i) => i.pageId === slug)
  if (curCookieJson[curPageIndex]) {
    curCookieJson[curPageIndex].audienceTermId = audienceTermId
  }

  Cookies.set(SERVICE_CONNECTION_PAGE_COOKIES, JSON.stringify(curCookieJson))
}

export const colorMapping: CarePathColorType[] = [
  'primary',
  'secondary',
  'tertiary',
  'quaternary',
  'tertiary',
]

export const getSessionsColor = (
  navigating: ScrollToItemType[],
  colorShade: CarePathColorPattern,
) => {
  // const navigatingIds = navigating.map((i) => i.idScroll)
  // const bgColorById: { [key in string]?: string } = {}
  // spotlight.listSessions
  //   .map((i, idx) => {
  //     if (navigatingIds.includes(i.idScroll) && i.backgroundColor !== '') {
  //       console.log({ yes: i.idScroll })
  //       bgColorById[i.idScroll] = i.backgroundColor
  //     }
  //   })
  //   .filter(Boolean)
  // return navigating.map((i, idx) =>
  //   Object.keys(bgColorById).includes(i.idScroll)
  //     ? bgColorById[i.idScroll] || ''
  //     : colorShade[colorMapping[idx % colorMapping.length]],
  // )
  return navigating.map(
    (_i, idx) => colorShade[colorMapping[idx % colorMapping.length]],
  )
}

export const getServicePageParams = () =>
  JSON.parse(Cookies.get(SERVICE_CONNECTION_LATEST_ACCESS_COOKIES) || '{}')

const customScrollTo = (offset: number, callback?: () => void) => {
  const fixedOffset = offset.toFixed()
  const onScroll = function () {
    if (window.pageYOffset.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll)
      callback?.()
    }
  }

  window.addEventListener('scroll', onScroll)
  onScroll()
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  })
}

export const handleScrollToBlock = ({
  hash,
  isMobile,
  callback,
}: {
  hash: string
  isMobile: boolean
  callback?: () => void
}) => {
  const headerHeight = isMobile ? 0 : 69
  if (hash) {
    fastdom.measure(() => {
      const selector = document?.querySelector(`[data-hashtag="${hash}"]`)
      const gap = Number(selector?.getAttribute('data-gap') || 0)
      if (selector) {
        customScrollTo(
          window.scrollY +
            selector.getBoundingClientRect().top -
            headerHeight -
            gap,
          callback,
          // () => setHandleClickToScroll(false),
        )
      }
    })
  }
}
